(function() {

    'use strict';

    angular.module('vhols-date-select-list', ['vhols-dates','LocalStorageModule'])

        .controller('VholsDateSelectListCtrl', ['$scope', 'dates','localStorageService', function($scope, dates, localStorageService) {

            $scope.genDates = function(date) {

                var startFrom = ($scope.startFrom - 1),
                    dateRange = $scope.dateRange,
                    incrementBy = $scope.incrementBy,
                    allDates = [],
                    givenDate = date;

                givenDate.setHours(0,0,0,0);

                for (var i = 0; i < dateRange; i++){
                    var currentDate = dates(givenDate),
                        interval = startFrom++ * incrementBy,
                        incrementingDate = currentDate.addMonths(interval).asDate();

                    allDates.push(dates(incrementingDate).format('YYYY-MM') + '-01');
                }
                return allDates;
            }

            $scope.initPersistence = function() {

                var theDay = new Date();
                $scope.datesArray = $scope.genDates(theDay);
                $scope.selectedMonth = $scope.datesArray[0];

                if ($scope.persistKey) {
                    $scope.$watch('selectedMonth', function(value) {
                        localStorageService.set($scope.persistKey, value);
                    });

                    var storageStringAsDate = dates(localStorageService.get($scope.persistKey));
                    var firstListedDate = dates($scope.datesArray[0]);
                    var validDate = storageStringAsDate.isAfter(firstListedDate) ? true : false;

                    $scope.selectedMonth = ( (localStorageService.get($scope.persistKey) && validDate) ) ? localStorageService.get($scope.persistKey) :  $scope.selectedMonth;
                }
            }
        }])
        .directive('vholsDateSelectList', ["$templateCache", function($templateCache) {
            return {
                restrict: "E",
                replace: true,
                scope: {
                    incrementBy: '=',
                    dateRange: '=',
                    selectedFormat: '=',
                    startFrom: '=',
                    selectedMonth: '=',
                    persistKey: '@'
                },
                template: $templateCache.get('vholsDateSelectList.html'),
                controller: "VholsDateSelectListCtrl",
                link: function(scope, elem, attrs) {
	                scope.initPersistence();
	            }
            };
        }]);
})();
!function(){"use strict";angular.module("vhols-date-select-list").run(["$templateCache",function(t){t.put("vholsDateSelectList.html",'<div class="input-group select-group squared"><select class="form-control" ng-model="selectedMonth" ng-options="dt as (dt | date:selectedFormat) for dt in datesArray"></select><span class="input-group-addon inputAddon"><i class="glyphicon icon-chevron-down"></i></span></div>')}])}();